module.exports = __webpack_public_path__ + "static/media/email@.c9af7fc8.svg";